import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[appPhoneMask]',
})
export class PhoneMaskDirective implements OnInit {
  private previousValue = '';
  constructor(private el: ElementRef) {}
  ngOnInit(): void {
    this.mask();
  }

  @HostListener('input')
  mask() {
    const masked = this.createMask(this.el.nativeElement.value);
    if (masked !== this.previousValue) {
      this.el.nativeElement.value = masked;
      this.previousValue = masked;
      this.el.nativeElement.dispatchEvent(new Event('input'));
    }
  }

  createMask(value) {
    let maskedValue = value.replace(/\D/g, '');
    if (maskedValue.length === 0) {
      maskedValue = '';
    } else if (maskedValue.length <= 2) {
      maskedValue = maskedValue.replace(/^(\d{0,3})(.*)/, '($1)');
    } else if (maskedValue.length <= 7) {
      maskedValue = maskedValue.replace(/^(\d{0,2})(\d{0,5})(.*)/, '($1)$2');
    } else {
      maskedValue = maskedValue.replace(
        /^(\d{0,2})(\d{0,5})(\d{0,4})(.*)/,
        '($1)$2-$3'
      );
    }

    return maskedValue;
  }
}
